export class Messages {
    static readonly SomethingWrong = "Something went wrong, please try again later!"
    static readonly LongOperation = "This operation may take a bit time, please come back later."
    static readonly BucketAllConfirmation = "{0} unbucketed crashes will be bucketed. Are you sure?"
    static readonly ClearBucketsConfirmation = "All the buckets will be cleared. Are you sure?"
    static readonly ClearRebucketQueueConfirmation = "The rebucket queue will be cleared. Are you sure?"
    static readonly ClearStuckCrashesConfirmation = "Crashes stuck in progress will be cleared. Are you sure?"
}